import { createStore, applyMiddleware, compose } from 'redux';
import circularJSON from 'circular-json';
import promiseMiddleware from 'redux-promise-middleware';
import { addLocaleData } from 'react-intl';
import createSagaMiddleware from 'redux-saga';

import ja from 'react-intl/locale-data/ja';
import zh from 'react-intl/locale-data/zh';
import ko from 'react-intl/locale-data/ko';
import en from 'react-intl/locale-data/en';
import th from 'react-intl/locale-data/th';

import i18n from '../i18n/i18n';
import rootReducer from './reducers';
import sagas from './sagas';
import { getScreenSize } from '../utils';

addLocaleData([
  { ...ja[0], locale: 'ja_jp' },
  { ...zh[0], locale: 'zh_cn' },
  { ...ko[0], locale: 'ko_kr' },
  { ...en[0], locale: 'en' },
  { ...en[0], locale: 'en_id' },
  { ...en[0], locale: 'en_hk' },
  { ...th[0], locale: 'th_th' },
  { ...zh[0], locale: 'zh_hk' },
  { ...zh[0], locale: 'zh_tw' },
]);

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose; // eslint-disable-line
const sagaMiddleware = createSagaMiddleware();

const preloadedState = window.__PRELOADED_STATE__ && circularJSON.parse(window.__PRELOADED_STATE__); // eslint-disable-line
delete window.__PRELOADED_STATE__; // eslint-disable-line

let middleware = [promiseMiddleware(), sagaMiddleware];

if (process.env.NODE_ENV !== 'production') {
  const reduxLogger = require('redux-logger'); // eslint-disable-line
  const { createLogger } = reduxLogger;
  const loggerMiddleware = createLogger();
  middleware = [...middleware, loggerMiddleware];
}

export const configureStore = initialState =>
  createStore(rootReducer, initialState, composeEnhancers(applyMiddleware(...middleware)));

const initialState = {
  error: {},
  hairDiagnosis: {
    users: {},
  },
  intl: {
    defaultLocale: 'en',
    locale: 'ja_jp',
    messages: i18n.ja_jp,
  },
  locale: window.location.pathname.split('/')[1],
  newsAndEvents: new Set([]),
  pages: {},
  screenSize: getScreenSize(),
  searchables: [],
  seminars: {},
  seminarSpecifics: {},
  siteOptions: {},
  user: {},
};

const store = configureStore(preloadedState || initialState);
sagaMiddleware.run(sagas);

window.snapSaveState = () => {
  const state = circularJSON.stringify(store.getState());
  return { __PRELOADED_STATE__: state };
};

export default store;



// WEBPACK FOOTER //
// ./src/redux/store.js